export const appSettingsObjectsUsingProducts = "/app_settings/objects_using_products";
